import React from "react";
import { Reveal, Stagger, StaggerItem } from "../../lib/motion";
import { useApp } from "@/context/AppContext";

export default function Process() {
  const { t } = useApp();
  const steps = t("process.steps") || [];
  return (
    <section id="process" data-testid="process-section" className="relative py-20 md:py-28">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-[11px] tracking-[0.24em] uppercase text-black/75 mb-4 font-bold">
            {t("process.eyebrow")}
          </p>
          <h2 className="font-display font-black text-black leading-[1.02] tracking-tight text-4xl md:text-5xl lg:text-6xl">
            {t("process.title1")} <span className="text-black/55">{t("process.title2")}</span>
          </h2>
        </Reveal>
        <Stagger className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s) => (
            <StaggerItem key={s.n}>
              <div
                data-testid={`process-step-${s.n}`}
                className="h-full rounded-2xl p-6 bg-white/70 backdrop-blur border border-black/10"
              >
                <div className="font-display font-black text-black/25 text-5xl leading-none">{s.n}</div>
                <h3 className="mt-3 font-display font-black text-xl text-black tracking-tight">{s.title}</h3>
                <p className="mt-3 text-black/75 text-[14px] leading-relaxed">{s.body}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
